import Vuex from 'vuex';

import activation from './modules/activation';
import answerStrikes from './modules/answerStrikes';
import assetAssociations from './modules/assetAssociations';
import assetAssociationStates from './modules/assetAssociationStates';
import assetViews from './modules/asset-views';
import attachments from './modules/attachments';
import attachmentStates from './modules/attachmentStates';
import app from './modules/app';
import appState from './modules/appState';
import bookmarks from './modules/bookmarks';
import catalog from './modules/catalog';
import categories from './modules/categories';
import categoryStates from './modules/categoryStates';
import categoryStatuses from './modules/categoryStatuses';
import categoryTypes from './modules/categoryTypes';
import certifications from './modules/certifications';
import checklists from './modules/checklists';
import checklistStates from './modules/checklistStates';
import classifications from './modules/classifications';
import contentPartners from './modules/content-partners';
import contentSources from './modules/content-sources';
import dashboards from './modules/dashboards';
import dashboardWidgets from './modules/dashboardWidgets';
import decks from './modules/decks';
import difficultyLevels from './modules/difficulty-levels';
import discussions from './modules/discussions';
import flashcards from './modules/flashcards';
import flashcardMetadata from './modules/flashcardMetadata';
import flashcardSet from './modules/flashcardSet';
import flashcardStates from './modules/flashcardStates';
import flashcardStatuses from './modules/flashcardStatuses';
import groupings from './modules/groupings';
import highlightStates from './modules/highlightStates';
import learningModules from './modules/learningModules';
import learningModuleStates from './modules/learningModuleStates';
import learningPath from './modules/learningPath';
import mnemonics from './modules/mnemonics';
import mnemonicStates from './modules/mnemonicStates';
import navigationGroups from './modules/navigationGroups';
import navigationItems from './modules/navigationItems';
import productVars from './modules/productVars';
import purchases from './modules/purchases';
import purchaseOrders from './modules/purchaseOrders';
import purchaseReceipts from './modules/purchaseReceipts';
import questionnaires from './modules/questionnaires';
import questionnaireUserStates from './modules/questionnaireUserStates';
import questionsOfTheDay from './modules/questionsOfTheDay';
import quizzes from './modules/quizzes';
import ratings from './modules/ratings';
import search from './modules/search';
import session from './modules/session';
import simulation from './modules/simulation';
import simulationConfigs from './modules/simulationConfigs';
import streak from './modules/streak';
import tags from './modules/tags';
import topics from './modules/topics';
import topicStates from './modules/topicStates';
import ui from './modules/ui';
import user from './modules/user';
import userCertifications from './modules/userCertifications';
import userProfileConfigs from './modules/userProfileConfigs';
import userQuizzes from './modules/userQuizzes';
import webPages from './modules/webPages';

export default (Vue) => {
  Vue.use(Vuex);

  return new Vuex.Store({
    modules: {
      activation,
      answerStrikes,
      assetAssociations,
      assetAssociationStates,
      assetViews,
      attachments,
      attachmentStates,
      app,
      appState,
      bookmarks,
			catalog,
      categories,
      categoryStates,
      categoryStatuses,
      categoryTypes,
      certifications,
      checklists,
      checklistStates,
      classifications,
      contentPartners,
      contentSources,
      dashboards,
      dashboardWidgets,
      decks,
      difficultyLevels,
      discussions,
      flashcards,
      flashcardMetadata,
      flashcardSet,
      flashcardStates,
      flashcardStatuses,
      groupings,
      highlightStates,
      learningModules,
			learningModuleStates,
      learningPath,
      mnemonics,
      mnemonicStates,
      navigationGroups,
      navigationItems,
      productVars,
      purchases,
      purchaseOrders,
      purchaseReceipts,
      questionnaires,
      questionnaireUserStates,
      questionsOfTheDay,
      quizzes,
      ratings,
      search,
      session,
      simulation,
      simulationConfigs,
      streak,
      tags,
      topics,
      topicStates,
      ui,
      user,
      userCertifications,
      userProfileConfigs,
      userQuizzes,
      webPages,
    },
  });
};
